"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var VizClientFieldElement_1 = require("./VizClientFieldElement");
exports.dataDetailsSheetFieldsSectionTestId = 'data-details-sheet-fields-section';
exports.dataDetailsSheetFieldsWithCountHeaderTestId = 'data-details-sheet-fields-with-count-header';
/** A widget to display a list of fields being used by the current sheet */
function SheetFieldsList(props) {
    var count = Localize_1.Formatters.formatCount(props.datasourceFields.length + props.worksheetFields.length);
    return (React.createElement(ViewerPaneStyles_1.DetailsPaneSection, { "data-tb-test-id": exports.dataDetailsSheetFieldsSectionTestId },
        React.createElement(ViewerPaneStyles_1.FieldsSectionHeader, { "data-tb-test-id": exports.dataDetailsSheetFieldsWithCountHeaderTestId }, Localize_1.Messages.SheetFieldsInUseWithCount({ count: count })),
        React.createElement(ViewerPaneStyles_1.SheetFieldsListBody, { "data-tb-test-id": 'data-details-sheet-fields-list-body' },
            props.datasourceFields.map(function (field) {
                return React.createElement(VizClientFieldElement_1.VizClientFieldElement, { field: field, key: field.id, workbookVizportalUrlId: props.workbookVizportalUrlId });
            }),
            props.worksheetFields.map(function (field) {
                return React.createElement(VizClientFieldElement_1.VizClientFieldElement, { field: field, key: field.id });
            }))));
}
exports.SheetFieldsList = SheetFieldsList;
//# sourceMappingURL=SheetFieldsList.js.map